import { Outlet, useOutletContext } from "react-router";

import { ClientTabBase } from "@shared";

import { ClientDetailResponse } from "@/api";
import { ClientStatusWidget } from "@/pages/clients/client/components/client-status-widget/ClientStatusWidget";

import { ClientMasterDataActionButtons } from "./master-data-action-buttons/ClientMasterDataActionButtons";
import { ClientMasterDataNavigation } from "./master-data-navigation/ClientMasterDataNavigation";

export function MasterDataTab() {
  const client = useOutletContext<ClientDetailResponse>();

  return (
    <ClientTabBase
      tabActions={<ClientMasterDataActionButtons client={client} />}
      navigation={<ClientMasterDataNavigation />}
      navigationFooter={<ClientStatusWidget client={client} />}
    >
      <Outlet context={client} />
    </ClientTabBase>
  );
}
